import { observable, action, toJS, computed, runInAction } from "mobx";
import moment from "moment";
import { NonFrameworkProjectType } from "../constants/constants-container";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

export default class CreateMappingProjectStore {
  @observable bool_showModal = false;

  @observable
  obj_modalData = {
    projectName: "",
    projectType: NonFrameworkProjectType.MAPPING,
    description: "",
    projectOwners: [],
    finalizationDate: moment().format("YYYY-MM-DD"),
    relatedToFramework: "",
    relatedFrameworkProjectMid: "",
    isFastTrack: false,
    areBusinessConstraintsDisabled: false,
  };

  @observable
  ob_fetched_po_ma_data = {
    maintenanceAgencies: []
  };

  @observable bool_form_btn_locked = true;

  @observable selectedFrameworks = [];

  @observable arr_all_Frameworks = [];

  constructor(http, projectOwnerStore) {
    this.http = http;
    this.projectOwnerStore = projectOwnerStore;
    this.init();
  }
  @action
  init = () => {
    this.helper_fetch_po_data();
    this.helper_fetch_all_frameworks();
  };

  @action
  action_reload_init = () => {
    this.init();
  };

  // this mehotd unlock submit btn of form form :
  // Create New Mapping Project
  //service_unlock_CNMP_form_submit_btn
  helper_lock_CNMP_btn = () => {
    this.bool_form_btn_locked = false;
  };

  @action
  helper_fetch_all_frameworks = () => {
    try {
      this.arr_all_Frameworks = [];
      this.http.service_query_all_Frameworks().then(
        action(data => {
          if (data && data.results) {
            this.arr_all_Frameworks = data.results;
          }
        })
      );
    } catch (error) {
      console.log(error.message);
    }
  };

  @action
  helper_fetch_po_data = () => {
    if(IS_BIRD_APP) return;
    
    this.http.service_fetch_po_data().then(data => {
      try {
        this.ob_fetched_po_ma_data = {
          maintenanceAgencies: data.maintenanceAgencies
        };
      } catch (error) {
        console.log("ob_fetched_po_ma_data", error.message);
      }
    });
  };
  //action_filter_mid
  //Create New Mapping Project <MODAL>
  //Related to Framework Project <Select />
  // GOAL : GET THE MA MID !!
  @action
  helper_find_ma_mids = () => {
    const data =
      this.ob_fetched_po_ma_data.maintenanceAgencies.map(
        helper_map_loop_ma
      )[0] || [];

    const a_ma_mids = data.map(helper_reduce_data);

    // RESULT is MA MID !!!
    return toJS(a_ma_mids[0]) || [];

    function helper_reduce_data(item) {
      return item.framework.mid;
    }

    function helper_map_loop_ma(item) {
      return item.projects.filter(helper_filter_ProjectType);
    }

    function helper_filter_ProjectType(ItemProject) {
      return ItemProject.project.projectType.includes("FRAMEWORK");
    }
  };

  @action
  helper_create_formData = (str_inputValue, str_inputName) => {
    switch (str_inputName) {
      case "projectType":
        this.obj_modalData.projectType = str_inputValue;
        break;

      case "name":
        this.obj_modalData.projectName = str_inputValue;
        break;
      
      case "description":
        this.obj_modalData.description = str_inputValue;
        break;

      case "projectOwners":
        this.obj_modalData.projectOwners = str_inputValue.map(item =>
          Number(item)
        );
        break;
      case "isFastTrack":
        this.obj_modalData.isFastTrack = !this.obj_modalData.isFastTrack;
        break;
      case "areBusinessConstraintsDisabled":
        this.obj_modalData.areBusinessConstraintsDisabled = !this.obj_modalData.areBusinessConstraintsDisabled;
        break;
      case "finalizationDate":
        const isoDate = str_inputValue.toISOString().split("T")[0];
        const helper_DateFormat = moment(isoDate).format("YYYY-MM-DD");
        this.obj_modalData.finalizationDate = helper_DateFormat;
        break;
      case "relatedFrameworkProjectMid":
        this.obj_modalData.relatedFrameworkProjectMid = str_inputValue;
        break;
      default:
        return true;
    }
  };

  // UI context
  @action
  action_toggle_CMFP_modal = () => {
    this.bool_showModal = !this.bool_showModal;
    this.resetModalData();
  };

  @action
  resetModalData = () => {
    this.obj_modalData = {
      projectName: "",
      projectType: NonFrameworkProjectType.MAPPING,
      description: "",
      projectOwners: [],
      finalizationDate: moment().format("YYYY-MM-DD"),
      relatedToFramework: "",
      relatedFrameworkProjectMid: "",
      isFastTrack: false,
      areBusinessConstraintsDisabled: false,
    };
    this.selectedFrameworks = [];
  };

  @action
  handleSelectedFrameworksChange = (frameworks) => {
    this.selectedFrameworks = frameworks;
  }

  @action
  action_create_mapping_project = () => {
    if(IS_BIRD_APP) return;
    
    runInAction(() => {
      const jsonToSend = {
        actionType: "CreateProject",
        project: {
          mid: this.obj_modalData.relatedFrameworkProjectMid,
          name: this.obj_modalData.projectName,
          projectType: this.obj_modalData.projectType,
          description: this.obj_modalData.description,
          finalizationDate: this.obj_modalData.finalizationDate,
          isFastTrack: this.obj_modalData.isFastTrack,
          areBusinessConstraintsDisabled: this.obj_modalData.areBusinessConstraintsDisabled,
        },
        projectOwners: this.obj_modalData.projectOwners,
      };

      if(this.selectedFrameworks.length > 0) {
        jsonToSend.frameworksToBeUsed = this.selectedFrameworks.map(framework => ({"tid" : framework}));
      }

      this.http.func_sendGeneralMessage(jsonToSend, response => {
        this.action_toggle_CMFP_modal();
      });
    });
  };

  @computed
  get getSelectedExistingFrameworks() {
    return this.selectedFrameworks;
  }

  @computed
  get getFrameworksInSelectedMaintenanceAgency() {
    return this.arr_all_Frameworks.filter(
      framework => framework.mid === this.obj_modalData.relatedFrameworkProjectMid).map(
        framework => {
          return {
            label: framework.name,
            value: framework.tid
          }
        }
      );
  }

  @computed
  get get_po_ma() {
    return this.ob_fetched_po_ma_data.maintenanceAgencies.map(maintenanceAgencies => ({
      label: maintenanceAgencies.maintenanceAgency.name,
      value: maintenanceAgencies.maintenanceAgency.tid
    }));
  }

  // UI : Create New Mapping Project MODAL
  // UI element: <SELECT />
  // UI label: Related to Framework Project:
  // GOAL : get the project name and project tid
  // and then  use it for jsonToSend
  @computed
  get computed_ui_arr_container_names_tides() {
    const frameworkProjectsPerMaintenanceAgency =
      this.ob_fetched_po_ma_data.maintenanceAgencies
        .map(helper_map_loop_ma)
        .map(helper_map_loop_projects);

    const data = [];
    frameworkProjectsPerMaintenanceAgency.forEach(ma => {
      ma.forEach(frameworkProject => {
        data.push(frameworkProject);
      })
    })

    // result is project name and tid
    return toJS(data);

    function helper_map_loop_ma(item) {
      return item.projects.filter(helper_filter_projects_for_Frameworks);
    }

    function helper_map_loop_projects(ItemProject) {
      return ItemProject.map(helper_map_reduce_for_name_and_tid);
    }

    function helper_map_reduce_for_name_and_tid(ob_project) {
      return {
        label: ob_project.project.name,
        value: ob_project.project.tid
      };
    }

    function helper_filter_projects_for_Frameworks(ItemProject) {
      return ItemProject.project.projectType.includes("FRAMEWORK");
    }
  }

  @computed
  get computed_get_obj_modalData() {
    return this.obj_modalData;
  }

  // if obj_modalData values are '' or [] then submit btn in
  // create map fram project will be disabled
  @computed
  get computed_bool_submit_btn_disabled() {
    const data = Object.values(toJS(this.obj_modalData)).some(item => {
      return item.length === 0;
    });

    return data;
  }

  @computed
  get computed_get_bool_showModal() {
    return this.bool_showModal;
  }

  @computed
  get po_computed_jsonToSend() {
    return this.jsonToSend;
  }

  @computed
  get computed_RESET_obj_modalData() {
    return this.RESET_obj_modalData;
  }
}